export const TEAL = "#00bcd4";
export const TEAL_ESCURO = "#00acc1";
export const NAVY = "#132350";
export const AZUL = "#1976d2";
export const AMARELO_ALTERADO = "#fffde7";
export const CINZA_IGNORADO = "#f0f0f0";

export const SUPERFICIE = "#F5F7FB";
export const BORDA_SUAVE = "rgba(19, 35, 80, 0.08)";
export const BORDA_SUAVE_CLARA = "rgba(19, 35, 80, 0.06)";
export const SOMBRA_CARD = "0px 2px 16px rgba(19, 35, 80, 0.06)";

export const formatarMoeda = (valor) =>
    Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
    });

export const formatarDia = (dia) =>
    (dia === null || dia === undefined) ? "—" : String(dia).padStart(2, "0");

const MESES = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

export const formatarPeriodoExtenso = (periodo) => {
    if (!/^\d{6}$/.test(periodo || "")) return periodo || "";
    const mes = Number(periodo.slice(4, 6));
    if (mes < 1 || mes > 12) return periodo;
    return `${MESES[mes - 1]} De ${periodo.slice(0, 4)}`;
};

export const STATUS_OS = {
    G: "Gerado",
    C: "Confirmado",
    I: "Integrado",
    X: "Ignorado"
};

export const rotuloStatus = (status) => STATUS_OS[status] || "Não gerado";

export const STATUS_IGNORADO = "X";

export const linhaIgnorada = (item) => item?.statusOS === STATUS_IGNORADO;

export const somarTotalFaturamento = (itens = []) =>
    itens.reduce((soma, item) => (linhaIgnorada(item) ? soma : soma + Number(item.totalFaturamento || 0)), 0);

const STATUS_BLOQUEIA_EDICAO = ["C", "I", "X"];

export const bloqueadoPorStatus = (status) => STATUS_BLOQUEIA_EDICAO.includes(status);

export const ACOES_HISTORICO = {
    ...STATUS_OS,
    R: "Reconsiderado",
    D: "Desconfirmado"
};

export const rotuloAcaoHistorico = (acao) => ACOES_HISTORICO[acao] || acao;

export const formatarDataHora = (iso) => {
    if (!iso) return "—";
    const data = new Date(iso);
    if (Number.isNaN(data.getTime())) return "—";
    const dd = String(data.getDate()).padStart(2, "0");
    const mm = String(data.getMonth() + 1).padStart(2, "0");
    const hh = String(data.getHours()).padStart(2, "0");
    const min = String(data.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${data.getFullYear()} ${hh}:${min}`;
};

export const mensagemErroApi = (erro, padrao) =>
    erro?.response?.data?.mensagem || padrao;
